export const PRICE_OF_STAY_REQUEST = 'PRICE_OF_STAY_REQUEST';
export const RESET_PRICE_OF_STAY = 'RESET_PRICE_OF_STAY';
export const ALL_INCLUSIVE_SERVICES_REQUEST = 'ALL_INCLUSIVE_SERVICES_REQUEST';
